export default __webpack_public_path__ + "d6a40df2b6906f1fc04f33a892531812.png";